<template>
  <div class="keycloak-access"></div>
</template>

<script>
export default {
  name: "VueKeycloakBeacon",

  mounted() {
    window.parent.postMessage("beacon-load", this.getOrigin());
  },
  methods: {
    getOrigin() {
      return (
        window.location.origin ||
        window.location.protocol + "://" + window.location.host
      );
    }
  }
};
</script>

<style>
.keycloak-access {
  height: 100vh;
}
</style>
